// src/config.ts
// API URL is injected at build time via VITE_API_BASE_URL environment variable
// Defaults to production API if not set
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://dev.api.mentoros.gr';

// SDK Base URL - path is set via VITE_SDK_PATH in CI/CD workflow
// /dev for development, /latest for stage/production
export const SDK_BASE_URL = 'https://sdk.mentoros.gr';
export const SDK_PATH = import.meta.env.VITE_SDK_PATH || '/latest';
export const getSDKUrl = (file: string) => `${SDK_BASE_URL}${SDK_PATH}/${file}`;

/**
 * The WordPress plugin, published beside the SDK.
 *
 * Deliberately NOT under SDK_PATH: a merchant on the staging dashboard still installs the released
 * plugin into a real WordPress, and the plugin carries its own update channel from there. Pinning
 * this to /dev would hand somebody an unreleased build with no way back.
 */
export const WORDPRESS_PLUGIN_URL = `${SDK_BASE_URL}/wordpress/mentoros-for-woocommerce.zip`;